module.exports = __webpack_public_path__ + "img/talk_nodata.8c181f65.svg";